import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { FeeDto } from './loan-od-accounts-fee-dto.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { AlertService } from 'ng-jhipster';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LoanOdAccountsChargeFeeResolve implements Resolve<FeeDto> {

    constructor(private loanOdAccountsService: LoanOdAccountsService,
        private alertService: AlertService,
        private router: Router) { }

    resolve(route: ActivatedRouteSnapshot) {
        if (route.paramMap.get('accountId')) {
            return this.loanOdAccountsService.findChargeFeeEntry(route.paramMap.get('accountId')).pipe(map(
                (res) => { return res; }
            )).pipe(catchError(
                (err) => {
                    this.onSaveError(err);
                    return of(null);
                }
            ));
        } else {
            return new FeeDto();
        }
    }

    private onSaveError(error) {
        try {
            const errorString = error.error.localizedMessage;
            if (errorString) {
                this.alertService.error(errorString);
            } else {
                this.onError(error);
            }
        } catch (exception) {
            try {
                const errorString = error.text();
                if (errorString) {
                    this.alertService.error(errorString);
                } else {
                    this.onError(error);
                }
            } catch (exception) {
                this.onError(error);
            }
        }
        this.router.navigate(['/loan-od-accounts']);
    }

    private onError(error) {
        const result = error;
        this.alertService.error(error);
        this.router.navigate(['/loans/loan-od-accounts']);
    }
}
